import { useEffect, useMemo, useState } from 'react'

const normalizeAvatarSource = (entity) => {
	if (!entity) {
		return ''
	}

	return entity.avatarUrl || ''
}

const ScoutAvatar = ({
	entity,
	alt,
	className,
	fallback,
	imgStyle,
	imgClassName = 'scout-avatar-image',
}) => {
	const resolvedSource = useMemo(() => normalizeAvatarSource(entity), [entity])
	const [imageFailed, setImageFailed] = useState(false)

	useEffect(() => {
		setImageFailed(false)
	}, [resolvedSource])

	if (resolvedSource && !imageFailed) {
		return (
			<img
				className={[className, imgClassName].filter(Boolean).join(' ')}
				src={resolvedSource}
				alt={alt}
				style={imgStyle}
				onError={() => setImageFailed(true)}
			/>
		)
	}

	if (typeof fallback === 'function') {
		return fallback()
	}

	return fallback || null
}

export default ScoutAvatar